import * as React from 'react';
import { SVGProps } from 'react';

const SvgPaletteIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width="24px" height="24px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 3c-4.952 0-9 4.048-9 9s4.048 9 9 9c1.23 0 2.166-.997 2.166-2.2a2.219 2.219 0 0 0-.598-1.5c-.068-.067-.117-.149-.117-.34v-.014a.525.525 0 0 1 .532-.533h1.647c2.948 0 5.364-2.414 5.364-5.362v-.005C20.967 6.561 16.827 3 12 3Zm-7.364 9c0-4.048 3.316-7.364 7.364-7.364 4.108 0 7.337 3.004 7.357 6.417a3.744 3.744 0 0 1-3.727 3.724h-1.627a2.159 2.159 0 0 0-2.189 2.19c.002.568.187 1.07.576 1.47a.58.58 0 0 1 .14.364c0 .34-.245.563-.53.563-4.048 0-7.364-3.316-7.364-7.364Zm8.591-4.09a.41.41 0 1 0 0-.82.41.41 0 0 0 0 .82ZM12 7.5a1.227 1.227 0 1 1 2.455 0A1.227 1.227 0 0 1 12 7.5Zm4.5 3.682a.41.41 0 1 0 0-.819.41.41 0 0 0 0 .819Zm-1.227-.41a1.227 1.227 0 1 1 2.454 0 1.227 1.227 0 0 1-2.454 0ZM9.545 8.319a.41.41 0 1 1-.818 0 .41.41 0 0 1 .818 0Zm-.409-1.227a1.227 1.227 0 1 0 0 2.454 1.227 1.227 0 0 0 0-2.454ZM7.5 12.818a.41.41 0 1 0 0-.818.41.41 0 0 0 0 .818Zm-1.227-.409a1.227 1.227 0 1 1 2.454 0 1.227 1.227 0 0 1-2.454 0Z"
      fill="currentColor"
    />
  </svg>
);

export default SvgPaletteIcon;
